import { useCallback, useMemo } from "react";
import { useAtom } from "jotai";
import { HISTORY_LIMIT } from "../../../TimeWindow.constants";
import type { TimeWindowRecentEntry } from "../../../TimeWindow.recent.types";
import {
  getTimeWindowSelectionLabel,
  isValidTimeWindowSelection,
  parseTimeWindowSelection,
} from "../../../TimeWindow.selection";
import { getShortTimeWindowLabel } from "../../../TimeWindow.utils";
import { timeWindowRecentAtom } from "../components/TimeWindowRecentlySelectedOptions/TimeWindowRecentlySelectedOptions.atoms";

export const getRecentEntryLabel = (entry: TimeWindowRecentEntry): string => {
  const parsed = parseTimeWindowSelection(entry);

  return parsed?.kind === "range"
    ? getShortTimeWindowLabel([parsed.start, parsed.end])
    : getTimeWindowSelectionLabel(entry);
};

export const useTimeWindowRecentHistory = () => {
  const [stored, setRecent] = useAtom(timeWindowRecentAtom);

  // Entries persisted before selections became tokens are minute numbers, which
  // no longer resolve to anything selectable.
  const recent = useMemo(() => stored.filter(isValidTimeWindowSelection), [stored]);

  const pushRecent = useCallback(
    (entry: TimeWindowRecentEntry) => {
      setRecent((prev) => {
        const valid = prev.filter(
          (item) => isValidTimeWindowSelection(item) && item !== entry
        );
        return [entry, ...valid].slice(0, HISTORY_LIMIT);
      });
    },
    [setRecent]
  );

  return { recent, pushRecent, getRecentEntryLabel };
};
